<template>
<div>
<h1>KSL Monitoring</h1>
<p>Get instant email alerts whenever an item you're looking for gets posted on KSL.</p>

<div class="priceBoxContainer">
<div class="priceBox">
  <h2>Basic</h2>
  <p>Basic Category & Subcategory Monitoring</p>
  <h3><sup>$</sup>5<small>/month</small></h3>
  <ul>
    <li>1 Search/Month</li>
    <li>Updated Every 10 Minutes</li>
    <li>$5 per additional search</li>
  </ul>
  <a href="#" class="button" style="background:orange;">Get a 7-Day Free Trial</a>
  <a href="#" class="button" style="background:transparent;border:1px solid;">Sign Up</a>
</div>
  <div class="priceBox">
  <h2>Hobbyist</h2>
  <p>Find affordable items close to you with Zip Code & Price Filters.</p>
        <h3><sup>$</sup>10<small>/month</small></h3>
  <ul>
    <li>2 Searches/Month</li>
    <li>Updated Every 5 Minutes</li>
          <li>$5 per additional search</li>
  </ul>
  <a href="#" class="button">Sign Up</a>
</div>
  <div class="priceBox">
  <h2>Professional</h2>
  <p>Monitor for specific items with keyword searches.</p>
        <h3><sup>$</sup>25<small>/month</small></h3>
  <ul>
    <li>3 Searches/Month</li>
    <li>Updated once every minute</li>
          <li>$5 per additional search</li>
  </ul>
  <a href="#" class="button">Sign Up</a>
</div>
</div>
</div>
</template>

<script>

export default {
  name: 'Home'
}
</script>
